import React from 'react';
import { 
    FlexDiv, 
    SpaceBetweenDiv,
    Heading3,
    ThemedButton,
    TextDefault
} from '@awarego-ui/components';
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from '@mui/icons-material/Close';

function EditorToolbar({ 
    question, 
    isDirty, 
    onSave, 
    onPreview, 
    onCancel 
}) {
    return (
        <div className="editor-toolbar">
            <SpaceBetweenDiv alignCenter padding={16}>
                <FlexDiv alignCenter gap={16}>
                    <Heading3>Question Editor</Heading3>
                    {isDirty && (
                        <TextDefault color="warning">
                            • Unsaved changes
                        </TextDefault>
                    )}
                </FlexDiv>
                
                <FlexDiv alignCenter gap={12}>
                    <ThemedButton
                        mode="secondary"
                        startIcon={<PreviewIcon />}
                        onClick={onPreview}
                        text="Preview"
                    />
                    
                    <ThemedButton
                        mode="primary"
                        startIcon={<SaveIcon />}
                        onClick={onSave}
                        disabled={!isDirty}
                        text="Save Question"
                    />
                    
                    <ThemedButton
                        mode="secondary"
                        startIcon={<CloseIcon />}
                        onClick={onCancel}
                        text="Cancel"
                    />
                </FlexDiv>
            </SpaceBetweenDiv>
        </div>
    );
}

export default EditorToolbar;

